module.exports = __webpack_public_path__ + "img/fondovi.acd57f87.png";